import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { POOL_NAME } from '@/constants';
import { refreshTokenConfig } from '@/oidcConfig';
import { clearOnLogOut, refreshSign } from '@/slices/authSlice';
import { RootState } from '@/store';

export const useTokenAutoRefresh = () => {
  const dispatch = useDispatch();
  const authSlice = useSelector((state: RootState) => state.auth);
  const authSliceMessage = authSlice?.status?.message;
  const {
    accessToken,
    refreshToken,
    isOidcClient,
    status: authError
  } = authSlice;

  const user = useSelector((state: RootState) => state.userProfile);
  const userMessage = user?.status?.message;

  const auditableElements = useSelector(
    (state: RootState) => state.auditableElements
  );
  const auditableElementsMessage = auditableElements?.status?.message;

  useEffect(() => {
    if (isOidcClient) return;
    if (!refreshToken) return;
    if (authSliceMessage === 'loading') return;
    if (auditableElementsMessage === 'loading') return;
    if (userMessage === 'loading') return;

    const { refreshTime, expiresInSec } = refreshTokenConfig(authSlice);

    if (expiresInSec <= 60) {
      dispatch(
        refreshSign({
          refreshToken,
          username: user?.username,
          poolName: POOL_NAME
        }) as any
      );
      return;
    }

    const revokeTokenTimer = setTimeout(() => {
      dispatch(
        refreshSign({
          refreshToken,
          username: user?.username,
          poolName: POOL_NAME
        }) as any
      );
    }, refreshTime);

    return () => clearTimeout(revokeTokenTimer);
  }, [
    refreshToken,
    authSliceMessage,
    dispatch,
    userMessage,
    auditableElementsMessage
  ]);

  useEffect(() => {
    if ([authError?.code].includes(401)) {
      dispatch(clearOnLogOut() as any);
    }
  }, [authError?.code, dispatch]);

  useEffect(() => {
    if (!accessToken) {
      dispatch(clearOnLogOut() as any);
    }
  }, [accessToken]);
};
